<template>
  <v-avatar
    :size="size"
    :color="backgroundColor"
    class="user-avatar"
  >
    <span class="user-avatar__initials" :style="{ fontSize: `${fontSize}px` }">
      {{ initials }}
    </span>
  </v-avatar>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  email: string
  name?: string
  size?: number | string
}

const props = withDefaults(defineProps<Props>(), {
  size: 48
})

const initials = computed(() => {
  if (props.name) {
    const parts = props.name.trim().split(' ')
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
    }
    return parts[0].substring(0, 2).toUpperCase()
  }
  return props.email.substring(0, 2).toUpperCase()
})

const backgroundColor = computed(() => {
  const hash = props.email.split('').reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 5) - acc)
  }, 0)

  const hue = Math.abs(hash % 360)
  return `hsl(${hue}, 60%, 50%)`
})

const fontSize = computed(() => {
  const sizeNum = typeof props.size === 'string' ? parseInt(props.size) : props.size
  return Math.floor(sizeNum * 0.4)
})
</script>

<style scoped lang="scss">
.user-avatar {
  font-weight: 600;

  &__initials {
    color: white;
    line-height: 1;
  }
}
</style>
